import { $http } from '@/plugins/axios';
import { AxiosResponse } from 'axios';

export const screeningService = {
	list: (params: {
		screening_scale_id?: number;
		student_id?: number | string;
		state?: string;
		order_by?: string;
	}): Promise<AxiosResponse> => {
		return $http.get('v1/staff/student_screening_scales', { params });
	},
	scales: (): Promise<AxiosResponse> => {
		return $http.get('v1/staff/screening_scales');
	},
	create: (
		studentId: number | string,
		data: {
			student_id: number | string;
			screening_scale_id: number | string;
			title: string;
		}
	): Promise<AxiosResponse> => {
		return $http.post(
			`v1/staff/students/${studentId}/screening_scales`,
			data
		);
	},
	questions: (
		studentId: number | string,
		screeningId: number | string,
		params: { page: number; page_size: number }
	): Promise<AxiosResponse> => {
		return $http.get(
			`v1/staff/students/${studentId}/screening_scales/${screeningId}/screening_scale_questions`,
			{ params }
		);
	},
	saveAnswer: (
		studentId: number | string,
		screeningId: number | string,
		data: {
			screening_scale_question_id: number | string;
			screening_scale_choice_id: number | string;
		}
	): Promise<AxiosResponse> => {
		return $http.put(
			`v1/staff/students/${studentId}/screening_scales/${screeningId}/answers`,
			data
		);
	},
	result: (
		studentId: number | string,
		screeningId: number | string
	): Promise<AxiosResponse> => {
		return $http.get(
			`v1/staff/students/${studentId}/screening_scales/${screeningId}/result`
		);
	},
	submit: (
		studentId: number | string,
		screeningId: number | string,
		data: {
			state: string;
			title: string;
			note: string;
		}
	): Promise<AxiosResponse> => {
		return $http.put(
			`v1/staff/students/${studentId}/screening_scales/${screeningId}`,
			data
		);
	},
	listFiles: (
		studentId: number | string,
		screeningId: number | string
	): Promise<AxiosResponse> => {
		return $http.get(
			`v1/staff/students/${studentId}/screening_scales/${screeningId}/files`
		);
	},
	deleteFile: (
		studentId: number | string,
		screeningId: number | string,
		fileId: number | string
	): Promise<AxiosResponse> => {
		return $http.delete(
			`v1/staff/students/${studentId}/screening_scales/${screeningId}/files/${fileId}`
		);
	},
	uploadFile: (
		studentId: number | string,
		screeningId: number | string,
		data: {
			asset_key: string;
			mime_type: string;
			name: string;
			signature: string;
		}
	): Promise<AxiosResponse> => {
		return $http.post(
			`v1/staff/students/${studentId}/screening_scales/${screeningId}/files`,
			data
		);
	},
	simple: (
		studentId: number | string,
		screeningId: number | string
	): Promise<AxiosResponse> => {
		return $http.get(
			`v1/staff/students/${studentId}/screening_scales/${screeningId}/simple`
		);
	},
	detail: (
		studentId: number | string,
		screeningId: number | string
	): Promise<AxiosResponse> => {
		return $http.get(
			`v1/staff/students/${studentId}/screening_scales/${screeningId}`
		);
	},
	send: (
		studentId: number | string,
		screeningId: number | string
	): Promise<AxiosResponse> => {
		return $http.put(
			`v1/staff/students/${studentId}/screening_scales/${screeningId}/send`
		);
	},
	remove: (
		studentId: number | string,
		screeningId: number | string
	): Promise<AxiosResponse> => {
		return $http.delete(
			`v1/staff/students/${studentId}/screening_scales/${screeningId}`
		);
	},
};
